<template>
  <div class="add-location-container">
    <modal id="add-location" class="add-location-modal">
      <template slot="header"> Add Vendor Location </template>
      <div class="form-group">
        <label>Street Address</label>

        <div class="input-group input-group-merge mb-3">
          <input
            id="address-field"
            type="text"
            class="form-control form-control-appended"
            v-model="address"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <span
                v-if="address"
                @click="clearSearch"
                class="fa text-danger fa-times cursor-pointer"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="addressRecord">
        <i class="fas fa-map-marker-alt"></i>
        <span class="pl-2">
          {{ addressRecord.formatted_address }}
        </span>
      </div>
      <div v-if="addressRecord" class="d-flex flex-wrap">
        <div class="actions-container col-12">
          <p v-if="coverageAreas.length" class="mb-1 text-deep-success">
            {{ coverageAreas.length }} Area{{
              coverageAreas.length > 1 ? "s" : ""
            }}
            Added
          </p>

          <button
            type="button"
            class="btn btn-sm btn-primary mb-2"
            v-if="tempSelectedAreas.length"
            @click="saveTempAreas()"
          >
            <i class="fas fa-plus"></i>
            Add {{ tempSelectedAreas.length }} Selected Area{{
              tempSelectedAreas.length > 1 ? "s" : ""
            }}
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary mb-2"
            v-if="!tempSelectedAreas.length"
            :disabled="drawStarted"
            @click="addArea()"
          >
            <span v-if="!drawStarted">
              <i class="fas fa-plus"></i>
              Add {{ coverageAreas.length ? "More" : "Coverage Area" }}
            </span>
            <span v-else>
              <i class="fas fa-draw-polygon"></i>
              Drawing Enabled
            </span>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger mb-2 ml-3"
            v-if="coverageAreas.length"
            @click="resetAreas()"
          >
            Reset
          </button>
          <p class="text-secondary mb-0 small">
            <span v-if="!drawStarted">
              Click on add coverage area/add more button then y</span
            >
            <span v-else>Y</span>ou can draw a polygon by clicking and dragging
            on the map.
          </p>
        </div>
        <div class="map-container col-12">
          <Map
            v-if="!gettingAddress"
            ref="vendorMap"
            :markers="[
              {
                lat: addressRecord.geometry.location.lat(),
                lng: addressRecord.geometry.location.lng(),
              },
            ]"
            :lat="addressRecord.geometry.location.lat()"
            :lng="addressRecord.geometry.location.lng()"
            :allowDrawing="true"
            :defaultZoom="12"
            @areaSelected="addAreaToAddress($event)"
          ></Map>
        </div>
      </div>
      <template slot="footer">
        <div class="row align-items-center mr-auto" v-if="addressRecord">
          <input
            type="text"
            placeholder="Clinic/Facility/Professional Name (Optional)"
            class="form-control w-auto col-12 col-sm-auto"
            style="min-width: 340px"
            v-model="clinicName"
          />
        </div>
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="saveLocation"
          v-if="addressRecord"
        >
          <span v-if="!saving">Save</span>
          <span
            class="spinner-border spinner-border-sm"
            v-if="saving"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-secondary"
          data-dismiss="modal"
        >
          Close
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import _ from "lodash";
import gmapsInit from "@/utils/gmaps";
import { mapState } from "vuex";
import Map from "@/components/Map.vue";

export default {
  name: "AddLocation",
  components: {
    Map,
  },
  props: {
    vendor: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(["saving"]),
  },
  data: function () {
    return {
      address: "",
      clinicName: "",
      gettingAddress: false,
      coverageAreas: [],
      tempSelectedAreas: [],
      drawStarted: false,
      addressRecord: false,
      results: [],
      autocomplete: null,
    };
  },
  mounted() {
    this.initAutocomplete();
  },
  methods: {
    saveLocation: function () {
      let location = this.parseResults(this.addressRecord);
      location.clinic_name = this.clinicName ? this.clinicName.trim() : null;
      this.$store.dispatch("locations/save", {
        vendor: this.vendor,
        location: location,
        areas: this.coverageAreas,
      });
    },
    clearSearch: function () {
      this.address = "";
      this.clinicName = "";
      this.results = [];
      this.addressRecord = false;
      this.coverageAreas = [];
      this.tempSelectedAreas = [];
    },
    parseResults: function (location) {
      var ShouldBeComponent = {
        number: ["street_number"],
        unit: ["subpremise"],
        zip: ["postal_code"],
        street: ["street_address", "route"],
        state: [
          "administrative_area_level_1",
          "administrative_area_level_2",
          "administrative_area_level_3",
          "administrative_area_level_4",
          "administrative_area_level_5",
        ],
        city: [
          "locality",
          "sublocality",
          "sublocality_level_1",
          "sublocality_level_2",
          "sublocality_level_3",
          "sublocality_level_4",
        ],
        country: ["country"],
      };

      var address = {
        number: "",
        unit: "",
        zip: "",
        street: "",
        state: "",
        city: "",
        country: "",
        lat: "",
        lng: "",
      };

      location.address_components.forEach((component) => {
        for (var shouldBe in ShouldBeComponent) {
          if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (
              shouldBe === "country" ||
              shouldBe === "state" ||
              shouldBe === "street"
            ) {
              address[shouldBe] = component.short_name;
            } else {
              address[shouldBe] = component.long_name;
            }
          }
        }
      });

      address["lat"] = location.geometry.location.lat();
      address["lng"] = location.geometry.location.lng();
      return address;
    },
    initAutocomplete: async function () {
      const addressField = document.querySelector("#address-field");
      const google = await gmapsInit();
      const autocomplete = new google.maps.places.Autocomplete(addressField, {
        fields: ["address_components", "geometry", "formatted_address"],
        types: [],
      });
      this.autocomplete = autocomplete;
      addressField.focus();
      autocomplete.addListener("place_changed", this.fillInAddress);
    },
    fillInAddress: function () {
      this.gettingAddress = true;
      this.drawStarted = false;
      this.tempSelectedAreas = [];
      this.coverageAreas = [];
      const place = this.autocomplete.getPlace();
      if (place.address_components) {
        this.addressRecord = place;
      }
      setTimeout(() => {
        this.gettingAddress = false;
      }, 1);
    },
    addAreaToAddress(area) {
      this.tempSelectedAreas.push(area);
    },
    addArea() {
      this.$refs.vendorMap.startDrawing();
      this.drawStarted = true;
    },
    saveTempAreas() {
      this.tempSelectedAreas.forEach((area) => {
        this.coverageAreas.push(area);
      });
      this.tempSelectedAreas = [];
      this.$refs.vendorMap.stopDrawing();
      this.drawStarted = false;
    },
    resetAreas() {
      this.$refs.vendorMap.clearSelectedAreas();
      this.$refs.vendorMap.stopDrawing();
      this.coverageAreas = [];
      this.tempSelectedAreas = [];
      this.drawStarted = false;
    },
  },
};
</script>
<style lang="scss">
.pac-container {
  z-index: 99999;
}
.add-location-container {
  .add-location-modal {
    .modal-dialog {
      max-width: 900px;
      width: 90%;
    }
  }
  .map-container {
    height: 50vh;

    .map {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
